/**
 * @packageDocumentation
 * @module      P_Arm_P1P2.ts
 * @description Contains Emc related data for Arm P1P2
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import { toFixedDecimal } from "../utils";
export default class P_Arm_P1P2 {
    constructor() {
        this.M1WTempEst = '0';
        this.M2WTempEst = '0';
        this.M1VolMeas = '0';
        this.M1Current = '0';
        this.M2VolMeas = '0';
        this.M2Current = '0';
        this.M1ErrorCode = '0';
        this.M2ErrorCode = '0';
        this.M1Status = '0';
        this.M2Status = '0';
        this.M1Pos = '0';
        this.M1Velocity = '0';
        this.M2Pos = '0';
        this.M2Velocity = '0';
        this.ModuleDI = '0';
        this.vMotor = '0';
        this.vMotor36V = '0';
        this.vMotor12V = '0';
        this.vMotor5V = '0';
        this.vMotor3p3V = '0';
        this.vMotor5VLogic = '0';
        this.vMotor3VReference = '0';
        this.vMotor3VSecondReference = '0';
        this.vMotor2p5VOffset = '0';
        this.vMotor1p2VDspCore = '0';
    }
    static fromJSON(json) {
        if (json) {
            let p_Arm_P1P2 = new P_Arm_P1P2();
            if (json.M1WTempEst) {
                p_Arm_P1P2.M1WTempEst = toFixedDecimal(json.M1WTempEst);
            }
            if (json.M2WTempEst) {
                p_Arm_P1P2.M2WTempEst = toFixedDecimal(json.M2WTempEst);
            }
            if (json.M1VolMeas) {
                p_Arm_P1P2.M1VolMeas = toFixedDecimal(json.M1VolMeas);
            }
            if (json.M1Current) {
                p_Arm_P1P2.M1Current = toFixedDecimal(json.M1Current);
            }
            if (json.M2VolMeas) {
                p_Arm_P1P2.M2VolMeas = toFixedDecimal(json.M2VolMeas);
            }
            if (json.M2Current) {
                p_Arm_P1P2.M2Current = toFixedDecimal(json.M2Current);
            }
            if (json.M1ErrorCode) {
                p_Arm_P1P2.M1ErrorCode = toFixedDecimal(json.M1ErrorCode);
            }
            if (json.M2ErrorCode) {
                p_Arm_P1P2.M2ErrorCode = toFixedDecimal(json.M2ErrorCode);
            }
            if (json.M1Status) {
                p_Arm_P1P2.M1Status = toFixedDecimal(json.M1Status);
            }
            if (json.M2Status) {
                p_Arm_P1P2.M2Status = toFixedDecimal(json.M2Status);
            }
            if (json.M1Pos) {
                p_Arm_P1P2.M1Pos = toFixedDecimal(json.M1Pos);
            }
            if (json.M1Velocity) {
                p_Arm_P1P2.M1Velocity = toFixedDecimal(json.M1Velocity);
            }
            if (json.M2Pos) {
                p_Arm_P1P2.M2Pos = toFixedDecimal(json.M2Pos);
            }
            if (json.M2Velocity) {
                p_Arm_P1P2.M2Velocity = toFixedDecimal(json.M2Velocity);
            }
            if (json.ModuleDI) {
                p_Arm_P1P2.ModuleDI = toFixedDecimal(json.ModuleDI);
            }
            if (json.vMotor) {
                p_Arm_P1P2.vMotor = toFixedDecimal(json.vMotor);
            }
            if (json.vMotor36V) {
                p_Arm_P1P2.vMotor36V = toFixedDecimal(json.vMotor36V);
            }
            if (json.vMotor12V) {
                p_Arm_P1P2.vMotor12V = toFixedDecimal(json.vMotor12V);
            }
            if (json.vMotor5V) {
                p_Arm_P1P2.vMotor5V = toFixedDecimal(json.vMotor5V);
            }
            if (json.vMotor3p3V) {
                p_Arm_P1P2.vMotor3p3V = toFixedDecimal(json.vMotor3p3V);
            }
            if (json.vMotor5VLogic) {
                p_Arm_P1P2.vMotor5VLogic = toFixedDecimal(json.vMotor5VLogic);
            }
            if (json.vMotor3VReference) {
                p_Arm_P1P2.vMotor3VReference = toFixedDecimal(json.vMotor3VReference);
            }
            if (json.vMotor3VSecondReference) {
                p_Arm_P1P2.vMotor3VSecondReference = toFixedDecimal(json.vMotor3VSecondReference);
            }
            if (json.vMotor2p5VOffset) {
                p_Arm_P1P2.vMotor2p5VOffset = toFixedDecimal(json.vMotor2p5VOffset);
            }
            if (json.vMotor1p2VDspCore) {
                p_Arm_P1P2.vMotor1p2VDspCore = toFixedDecimal(json.vMotor1p2VDspCore);
            }
            return p_Arm_P1P2;
        }
        return null;
    }
}
//# sourceMappingURL=P_Arm_P1P2.js.map